import { render, staticRenderFns } from "./ticket-count-detail.vue?vue&type=template&id=4e06c44c"
import script from "./ticket-count-detail.vue?vue&type=script&lang=js"
export * from "./ticket-count-detail.vue?vue&type=script&lang=js"
import style0 from "./ticket-count-detail.vue?vue&type=style&index=0&id=4e06c44c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports